import ZTogglePanel from './src/ZTogglePanel'

ZTogglePanel.install = function (Vue) {
    Vue.component(ZTogglePanel.name, ZTogglePanel);
};

export default ZTogglePanel;